'use client';

import React from 'react';

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { NavLinkContext } from '@ergeon/core-components';

import { ROUTES } from './routes';
import { TwilioContextProvider } from './context-providers/TwilioContext';
import { CallHistoryContextProvider } from './context-providers/CallHistoryContext';
import NavLinkAdapter from './components/NavLinkAdapter';
import { AuthContextProvider } from './context-providers/AuthContext';
import { UnifiedDialogContextProvider } from './context-providers/UnifiedDialogContext';
import { CentrifugoContextProvider } from './context-providers/CentrifugoContext';
import { StaffFilterContextProvider } from './context-providers/StaffFilterContext';
import { ModalProvider } from './modals';
import { UrlModalHandler } from './modals/urlModals';
import CallsPage from './pages/CallsPage';
import CallDetailPage from './pages/CallDetailPage';
import CallNewPage from './pages/CallNewPage';
import CustomersListPage from './pages/CustomersListPage';
import CustomerDetailsPage from './pages/CustomerDetailsPage';
import ActivitiesPage from './pages/ActivitiesPage';
import AIAgentPage from './pages/AIAgentPage';
import OrdersPage from './pages/OrdersPage';
import SalesToolkitPage from './pages/SalesToolkitPage';
import NotFoundPage from './pages/NotFoundPage';
import RequireAuthUser from './auth/RequireAuthUser';
import { AgentContextProvider } from './context-providers/AgentContext';
import { KeyboardShortcutsProvider } from './context-providers/KeyboardShortcutsProvider';
import FloatingCallPanel from './components/FloatingCallPanel';
import GlobalKeyboardShortcuts from './components/GlobalKeyboardShortcuts';
import { NavigationInterceptor } from './components/NavigationInterceptor';
import { CallerIdInitializer } from './components/CallerIdInitializer';

export default function App() {
  return (
    <BrowserRouter>
      <NavLinkContext.Provider value={NavLinkAdapter}>
        <KeyboardShortcutsProvider>
          <AuthContextProvider>
            <AgentContextProvider>
              <TwilioContextProvider>
                <ModalProvider>
                  <UrlModalHandler>
                    <RequireAuthUser>
                      <UnifiedDialogContextProvider>
                        <CentrifugoContextProvider>
                          <CallerIdInitializer>
                            <NavigationInterceptor />
                            <GlobalKeyboardShortcuts />
                            <CallHistoryContextProvider>
                              <StaffFilterContextProvider>
                                <Routes>
                                  <Route element={<Navigate replace to={ROUTES.calls.$path()} />} path="/" />
                                  <Route element={<CallsPage />} path={ROUTES.calls.$path()} />
                                  <Route element={<CallDetailPage />} path={ROUTES.call.$path()} />
                                  <Route element={<CallNewPage />} path={ROUTES.callNew.$path()} />
                                  <Route element={<CustomersListPage />} path={ROUTES.customers.$path()} />
                                  <Route element={<CustomerDetailsPage />} path={ROUTES.customer.$path()} />
                                  <Route element={<ActivitiesPage />} path={ROUTES.activities.$path()} />
                                  <Route element={<AIAgentPage />} path={ROUTES.aiAgent.$path()} />
                                  <Route element={<OrdersPage />} path={ROUTES.orders.$path()} />
                                  <Route element={<SalesToolkitPage />} path={ROUTES.salesToolkit.$path()} />
                                  <Route element={<NotFoundPage />} path="*" />
                                </Routes>
                                <FloatingCallPanel />
                              </StaffFilterContextProvider>
                            </CallHistoryContextProvider>
                          </CallerIdInitializer>
                        </CentrifugoContextProvider>
                      </UnifiedDialogContextProvider>
                    </RequireAuthUser>
                  </UrlModalHandler>
                </ModalProvider>
              </TwilioContextProvider>
            </AgentContextProvider>
          </AuthContextProvider>
        </KeyboardShortcutsProvider>
      </NavLinkContext.Provider>
    </BrowserRouter>
  );
}
